var systemLocate = System.locate;
System.locate = function (load) {
  var System = this;
  return Promise.resolve(systemLocate.call(this, load)).then(function (address) {
    if (/^\?.+@?.+/.test(location.search)) return address;
    if (/[0-9a-fA-F]{10}/.test(address)) return address;
    if (address.indexOf("/modules/") === -1) return address;
    return address + "?" + (System.cacheBust ||  parseInt(new Date() / (1000 * 60 * 10)));
  });
};

SystemJS.config({
  baseURL: ".",
  trace: true,
  paths: {
    "views/": "modules/",
    "github:": "jspm_packages/github/",
    "npm:": "jspm_packages/npm/",
    "locales/": "modules/common/locales/"
  }
});

SystemJS.config({
    "bundles": {
        "app-0430e60304.bundle.ts": [
            "app.ts",
            "env.ts",
            "github:frankwallis/plugin-typescript@5.3.0.json",
            "libs/webix-extra/UIExtension.ts",
            "libs/webix-extra/helpers/validator.ts",
            "libs/webix-jet/jet-core/core.ts",
            "libs/webix-jet/jet-core/plugins/locale.ts",
            "libs/webix-jet/polyglot/build/polyglot.js",
            "libs/webix-jet/routie/lib/routie.js",
            "locale.ts",
            "modules/common/env/isc.ts",
            "modules/common/env/summer.ts",
            "modules/common/env/xfusion.ts",
            "modules/common/extra/session/jalor5session.ts",
            "modules/common/extra/web-storage-cache/ajax-cache.ts",
            "modules/common/extra/web-storage-cache/web-storage-cache.js!js"
        ],
        "libs/webix-extra/webix-extra-all-333b83eaac.bundle.ts": [
            "github:social4hyq/systemjs-less-plugin@1.8.1.json",
            "libs/webix-extra/bugfix.ts",
            "libs/webix-extra/bugfix/iefix.ts",
            "libs/webix-extra/components/eSpaceCtrl.js!js",
            "libs/webix-extra/components/goldenlayout/js/jquery-1.11.1.min.js!js",
            "libs/webix-extra/components/moment-timezone/moment-timezone.min.js",
            "libs/webix-extra/components/moment/moment.js",
            "libs/webix-extra/enhance.ts",
            "libs/webix-extra/enhance/EditAbility.ts",
            "libs/webix-extra/enhance/accordionitem.ts",
            "libs/webix-extra/enhance/active-content.ts",
            "libs/webix-extra/enhance/button.ts",
            "libs/webix-extra/enhance/calendar.ts",
            "libs/webix-extra/enhance/carousel/carousel.ts",
            "libs/webix-extra/enhance/checkbox/checkbox.ts",
            "libs/webix-extra/enhance/checksuggest.ts",
            "libs/webix-extra/enhance/clipbuffer.ts",
            "libs/webix-extra/enhance/data-processor.ts",
            "libs/webix-extra/enhance/data-store.ts",
            "libs/webix-extra/enhance/datadriver/wpfdriver.ts",
            "libs/webix-extra/enhance/datafilter/aggregationColumn.ts",
            "libs/webix-extra/enhance/datafilter/clearFilter.ts",
            "libs/webix-extra/enhance/datafilter/comboFilter.ts",
            "libs/webix-extra/enhance/datafilter/customAddRowColumn.ts",
            "libs/webix-extra/enhance/datafilter/customMasterCheckbox.ts",
            "libs/webix-extra/enhance/datafilter/customMasterTreeCheckbox.ts",
            "libs/webix-extra/enhance/datafilter/dateFilter.ts",
            "libs/webix-extra/enhance/datafilter/emptyFilter.ts",
            "libs/webix-extra/enhance/datafilter/excelFilter.ts",
            "libs/webix-extra/enhance/datafilter/hwColumnGroup.ts",
            "libs/webix-extra/enhance/datafilter/hwColumnHeader.ts",
            "libs/webix-extra/enhance/datafilter/hwDateFilterV2.ts",
            "libs/webix-extra/enhance/datafilter/hwMultiSelectFilterV2.ts",
            "libs/webix-extra/enhance/datafilter/hwRichselectFilter.ts",
            "libs/webix-extra/enhance/datafilter/hwSelectFilter.ts",
            "libs/webix-extra/enhance/datafilter/hwSelectFilterV2.ts",
            "libs/webix-extra/enhance/datafilter/hwServerSelectFilterV2.ts",
            "libs/webix-extra/enhance/datafilter/multiDateFilter.ts",
            "libs/webix-extra/enhance/datafilter/multiNumberFilter.ts",
            "libs/webix-extra/enhance/datafilter/server-filter.ts",
            "libs/webix-extra/enhance/datafilter/text-filter.ts",
            "libs/webix-extra/enhance/datatable/datatable.ts",
            "libs/webix-extra/enhance/datatable/plugins/hwAdjustRowHeight.ts",
            "libs/webix-extra/enhance/datatable/plugins/hwClipboard.ts",
            "libs/webix-extra/enhance/datatable/plugins/hwColumns.ts",
            "libs/webix-extra/enhance/datatable/plugins/hwDragColumn.ts",
            "libs/webix-extra/enhance/datatable/plugins/hwDragFill.ts",
            "libs/webix-extra/enhance/datatable/plugins/hwDragSelectCheckbox.ts",
            "libs/webix-extra/enhance/datatable/plugins/hwDynEditor.ts",
            "libs/webix-extra/enhance/datatable/plugins/hwEditable.ts",
            "libs/webix-extra/enhance/datatable/plugins/hwEdocColumn.ts",
            "libs/webix-extra/enhance/datatable/plugins/hwFrozenColumn.ts",
            "libs/webix-extra/enhance/datatable/plugins/hwHeadermenu.ts",
            "libs/webix-extra/enhance/datatable/plugins/hwHeadermenu/columnSizePreference.ts",
            "libs/webix-extra/enhance/datatable/plugins/hwHeadermenu/moveUtil.ts",
            "libs/webix-extra/enhance/datatable/plugins/hwMarkChangedCell.ts",
            "libs/webix-extra/enhance/datatable/plugins/hwMultiSort.ts",
            "libs/webix-extra/enhance/datatable/plugins/hwOnepage.ts",
            "libs/webix-extra/enhance/datatable/plugins/hwPopupSelect.ts",
            "libs/webix-extra/enhance/datatable/plugins/hwQuickEdit.ts",
            "libs/webix-extra/enhance/datatable/plugins/hwRefreshColumnIndex.ts",
            "libs/webix-extra/enhance/datatable/plugins/hwRules.ts",
            "libs/webix-extra/enhance/datatable/plugins/hwSelectedSpans.ts",
            "libs/webix-extra/enhance/datatable/plugins/hwSpans.ts",
            "libs/webix-extra/enhance/datatable/plugins/hwTablePaste.ts",
            "libs/webix-extra/enhance/datatable/plugins/hwToExcel.ts",
            "libs/webix-extra/enhance/datatable/plugins/hwToolBtn.ts",
            "libs/webix-extra/enhance/datatable/plugins/hwTooltip.ts",
            "libs/webix-extra/enhance/datepicker.ts",
            "libs/webix-extra/enhance/debug.ts",
            "libs/webix-extra/enhance/editors/date.ts",
            "libs/webix-extra/enhance/editors/dialog.ts",
            "libs/webix-extra/enhance/editors/editableDate.ts",
            "libs/webix-extra/enhance/editors/editablehwquickdatepicker.ts",
            "libs/webix-extra/enhance/editors/editors.ts",
            "libs/webix-extra/enhance/editors/hwAdvancedDatepickerV2.ts",
            "libs/webix-extra/enhance/editors/hwDatepickerV2.ts",
            "libs/webix-extra/enhance/editors/hwMultidatepickerV2.ts",
            "libs/webix-extra/enhance/editors/hwRichSelectV2.ts",
            "libs/webix-extra/enhance/editors/hwcheckbox.ts",
            "libs/webix-extra/enhance/editors/hwmultiuser.ts",
            "libs/webix-extra/enhance/editors/hwnumber.ts",
            "libs/webix-extra/enhance/editors/hwquickdatepicker.ts",
            "libs/webix-extra/enhance/editors/hwtextarea.ts",
            "libs/webix-extra/enhance/editors/hwtextpopup.ts",
            "libs/webix-extra/enhance/editors/hwuser.ts",
            "libs/webix-extra/enhance/editors/multicombo.ts",
            "libs/webix-extra/enhance/editors/number.ts",
            "libs/webix-extra/enhance/editors/text.ts",
            "libs/webix-extra/enhance/editors/textCombo.ts",
            "libs/webix-extra/enhance/editors/textarea.ts",
            "libs/webix-extra/enhance/editors/w3user.ts",
            "libs/webix-extra/enhance/form/form.ts",
            "libs/webix-extra/enhance/hash.ts",
            "libs/webix-extra/enhance/label.ts",
            "libs/webix-extra/enhance/layout.ts",
            "libs/webix-extra/enhance/menu.ts",
            "libs/webix-extra/enhance/multicombo.ts",
            "libs/webix-extra/enhance/multiselect.ts",
            "libs/webix-extra/enhance/pager/pager.ts",
            "libs/webix-extra/enhance/pdfviewer.ts",
            "libs/webix-extra/enhance/proxy/hwsuggestpopupproxy.ts",
            "libs/webix-extra/enhance/proxy/hwsuggestproxy.ts",
            "libs/webix-extra/enhance/proxy/idservlet.ts",
            "libs/webix-extra/enhance/proxy/localstorage.ts",
            "libs/webix-extra/enhance/proxy/wpfconnector.ts",
            "libs/webix-extra/enhance/proxy/wpfproxy.ts",
            "libs/webix-extra/enhance/radio/radio.ts",
            "libs/webix-extra/enhance/resizer/resizer.ts",
            "libs/webix-extra/enhance/richselect/richselect.ts",
            "libs/webix-extra/enhance/rules/rules.ts",
            "libs/webix-extra/enhance/select.ts",
            "libs/webix-extra/enhance/suggest.ts",
            "libs/webix-extra/enhance/tabbar.ts",
            "libs/webix-extra/enhance/text.ts",
            "libs/webix-extra/enhance/textarea.ts",
            "libs/webix-extra/enhance/timeZone.ts",
            "libs/webix-extra/enhance/tooltip.ts",
            "libs/webix-extra/enhance/treeStore.ts",
            "libs/webix-extra/enhance/uploader/uploader.less!github:social4hyq/systemjs-less-plugin@1.8.1/less.js",
            "libs/webix-extra/enhance/uploader/uploader.ts",
            "libs/webix-extra/enhance/webix_toExcelV2.ts",
            "libs/webix-extra/getLanguage.ts",
            "libs/webix-extra/helpers/fullscreen.ts",
            "libs/webix-extra/helpers/util.ts",
            "libs/webix-extra/helpers/winbar.ts",
            "libs/webix-extra/hw/exportWindow/exportWindow.ts",
            "libs/webix-extra/hw/flexdatepicker/flexdatepicker.ts",
            "libs/webix-extra/hw/flexform/flexform.ts",
            "libs/webix-extra/hw/flexform/jalorAdapter.ts",
            "libs/webix-extra/hw/flexform/wpfAdapter.ts",
            "libs/webix-extra/hw/flexlayout/flexlayout.ts",
            "libs/webix-extra/hw/flexpopbox/flexpopbox-combo.ts",
            "libs/webix-extra/hw/flexpopbox/flexpopbox-text.ts",
            "libs/webix-extra/hw/flexpopbox/flexpopbox-winbody.ts",
            "libs/webix-extra/hw/flexpopbox/flexpopbox.ts",
            "libs/webix-extra/hw/flextable/before-update.ts",
            "libs/webix-extra/hw/flextable/flextable.ts",
            "libs/webix-extra/hw/flextable/plugins/before-update.ts",
            "libs/webix-extra/hw/flexuser/flexuser.ts",
            "libs/webix-extra/hw/flexuser/hwmultiuser.ts",
            "libs/webix-extra/hw/flexuser/userSuggest.ts",
            "libs/webix-extra/hw/fullscreen/window.ts",
            "libs/webix-extra/hw/hwAdvancedFilterV2/hwAdvancedFilterV2.ts",
            "libs/webix-extra/hw/hwAdvancedFilterV2/hwRadioItemV2.ts",
            "libs/webix-extra/hw/hwBubbleNumV2/hwBubbleNumV2.ts",
            "libs/webix-extra/hw/hwButtonV2/hwButtonV2.ts",
            "libs/webix-extra/hw/hwCalendarV2/hwCalendarV2.ts",
            "libs/webix-extra/hw/hwCarouselV2/hwCarouselV2.ts",
            "libs/webix-extra/hw/hwCascadeV2/hwCascadeListV2.ts",
            "libs/webix-extra/hw/hwCascadeV2/hwCascadeSuggestV2.ts",
            "libs/webix-extra/hw/hwCascadeV2/hwCascadeV2.ts",
            "libs/webix-extra/hw/hwCheckboxV2/hwCheckboxV2.ts",
            "libs/webix-extra/hw/hwChecksuggestV2/hwChecksuggestV2.ts",
            "libs/webix-extra/hw/hwComboV2/hwComboV2.ts",
            "libs/webix-extra/hw/hwCounterV2/hwCounterV2.ts",
            "libs/webix-extra/hw/hwDatatableV2/hwDatatableV2.ts",
            "libs/webix-extra/hw/hwDatepickerRangeV2/hwDatepickerRangeV2.ts",
            "libs/webix-extra/hw/hwDatepickerV2/hwAdvancedDatepickerV2.ts",
            "libs/webix-extra/hw/hwDatepickerV2/hwDatepickerPopupV2.ts",
            "libs/webix-extra/hw/hwDatepickerV2/hwDatepickerV2.ts",
            "libs/webix-extra/hw/hwDetailsInfoV2/hwDetailsInfoV2.ts",
            "libs/webix-extra/hw/hwDetailsInfoV2/hwLabelInfoV2.ts",
            "libs/webix-extra/hw/hwEditorsV2/hwDialogV2.ts",
            "libs/webix-extra/hw/hwEditorsV2/hwEditorsV2.ts",
            "libs/webix-extra/hw/hwEditorsV2/hwMultiselectV2.ts",
            "libs/webix-extra/hw/hwEflowMenu/hwEflowMenu.ts",
            "libs/webix-extra/hw/hwEspaceBtnV2/hwEspaceBtnV2.ts",
            "libs/webix-extra/hw/hwEspaceBtnV2/hwEspaceGroupBtnV2.ts",
            "libs/webix-extra/hw/hwEspaceBtnV2/hwEspaceImBtnV2.ts",
            "libs/webix-extra/hw/hwEspaceBtnV2/hwEspaceMailToBtnV2.ts",
            "libs/webix-extra/hw/hwEspaceBtnV2/hwEspaceTelBtnV2.ts",
            "libs/webix-extra/hw/hwEspaceBtnV2/hwEspaceWelinkBtnV2.ts",
            "libs/webix-extra/hw/hwFilterMultiselectV2/hwFilterChecksuggestV2.ts",
            "libs/webix-extra/hw/hwFilterMultiselectV2/hwFilterMultiselectV2.ts",
            "libs/webix-extra/hw/hwFlexdatepickerV2/hwFlexdatepickerV2.ts",
            "libs/webix-extra/hw/hwFlextableV2/before-update.ts",
            "libs/webix-extra/hw/hwFlextableV2/hwFlextableV2.ts",
            "libs/webix-extra/hw/hwFlextableV2/indexMasterTreeCheckbox.ts",
            "libs/webix-extra/hw/hwFlextableV2/plugins/before-update.ts",
            "libs/webix-extra/hw/hwFormV2/hwFormV2.ts",
            "libs/webix-extra/hw/hwGroupButtonV2/hwGroupButtonV2.less!github:social4hyq/systemjs-less-plugin@1.8.1/less.js",
            "libs/webix-extra/hw/hwGroupButtonV2/hwGroupButtonV2.ts",
            "libs/webix-extra/hw/hwGroupSearch/hwGroupSearch.ts",
            "libs/webix-extra/hw/hwHeadInfoV2/hwHeadInfoV2.ts",
            "libs/webix-extra/hw/hwIconBtnV2/hwIconBtnV2.ts",
            "libs/webix-extra/hw/hwLabelBtnV2/hwLabelBtnV2.ts",
            "libs/webix-extra/hw/hwMessageBoxV2/hwMessageBoxV2.ts",
            "libs/webix-extra/hw/hwMessageDialogV2/hwMessageDialogV2.ts",
            "libs/webix-extra/hw/hwMulticomboAll/hwMulticomboAll.ts",
            "libs/webix-extra/hw/hwMulticomboAll/hwchecksuggestV2.ts",
            "libs/webix-extra/hw/hwMulticomboV2/hwMulticomboV2.less!github:social4hyq/systemjs-less-plugin@1.8.1/less.js",
            "libs/webix-extra/hw/hwMulticomboV2/hwMulticomboV2.ts",
            "libs/webix-extra/hw/hwMultidatepickerV2/hwMultidatepickerV2.ts",
            "libs/webix-extra/hw/hwMultiselectV2/hwChecksuggestV2.ts",
            "libs/webix-extra/hw/hwMultiselectV2/hwMultiselectV2.ts",
            "libs/webix-extra/hw/hwMyCardInfoV2/hwMyCardInfoV2.ts",
            "libs/webix-extra/hw/hwRadioV2/hwRadioV2.ts",
            "libs/webix-extra/hw/hwResponsivetableV2/hwResponsivetableV2.less!github:social4hyq/systemjs-less-plugin@1.8.1/less.js",
            "libs/webix-extra/hw/hwResponsivetableV2/hwResponsivetableV2.ts",
            "libs/webix-extra/hw/hwRichselectV2/hwRichselectV2.ts",
            "libs/webix-extra/hw/hwScrollTextV2/hwScrollTextV2.ts",
            "libs/webix-extra/hw/hwSearchTreeV2/hwSearchTreeV2.ts",
            "libs/webix-extra/hw/hwSearchV2/hwSearchFilterV2.ts",
            "libs/webix-extra/hw/hwSearchV2/hwSearchV2.ts",
            "libs/webix-extra/hw/hwSegmentedV2/hwSegmentedV2.ts",
            "libs/webix-extra/hw/hwSelectUserV2/hwSelectUserV2.ts",
            "libs/webix-extra/hw/hwSideNavigationV2/hwSideNavigationV2.ts",
            "libs/webix-extra/hw/hwSideNavigationV2/hwSidebarList.ts",
            "libs/webix-extra/hw/hwSideNavigationV2/hwSidebarV2.ts",
            "libs/webix-extra/hw/hwSliderLayoutV2/hwSliderLayoutV2.ts",
            "libs/webix-extra/hw/hwSuggestpopupV2/hwSuggestpopupV2.ts",
            "libs/webix-extra/hw/hwSuggestpopupV2/hwpopupV2.ts",
            "libs/webix-extra/hw/hwSuggestpopupV2/hwsuggestV2.ts",
            "libs/webix-extra/hw/hwSuggestpopupV2/hwtextV2.ts",
            "libs/webix-extra/hw/hwSuggestpopupV2/popWinV2.ts",
            "libs/webix-extra/hw/hwSwitchV2/hwSwitchV2.ts",
            "libs/webix-extra/hw/hwTabviewV2/hwSubTabviewV2.ts",
            "libs/webix-extra/hw/hwTabviewV2/hwTabviewV2.ts",
            "libs/webix-extra/hw/hwTabviewV2/hwVerticalTabviewV2.ts",
            "libs/webix-extra/hw/hwTabviewV2/tabviewV2.ts",
            "libs/webix-extra/hw/hwTextPopupV2/hwTextPopupV2.ts",
            "libs/webix-extra/hw/hwTextSegment/hwTextSegment.ts",
            "libs/webix-extra/hw/hwTextV2/hwTextV2.ts",
            "libs/webix-extra/hw/hwTextV2/hwTextareaV2.ts",
            "libs/webix-extra/hw/hwTimer/hwTimer.ts",
            "libs/webix-extra/hw/hwTreeSelectV2/hwCheckTreeSelectV2.ts",
            "libs/webix-extra/hw/hwTreeSelectV2/hwPersonalTreeV2.ts",
            "libs/webix-extra/hw/hwTreeSelectV2/hwTreeSelectV2.ts",
            "libs/webix-extra/hw/hwTreeSelectV2/hwTreeSuggestV2.ts",
            "libs/webix-extra/hw/hwTreeV2/hwTreeV2.ts",
            "libs/webix-extra/hw/hwTreetableV2/hwTreetableV2.ts",
            "libs/webix-extra/hw/hwTurbo/hwTurbo.ts",
            "libs/webix-extra/hw/hwValidateV2/hwValidateV2.ts",
            "libs/webix-extra/hw/hwWizardV2/hwWizardBasicV2.ts",
            "libs/webix-extra/hw/hwWizardV2/hwWizardLabelV2.ts",
            "libs/webix-extra/hw/hwWizardV2/hwWizardTimeAscV2.ts",
            "libs/webix-extra/hw/hwWizardV2/hwWizardTimeDescV2.ts",
            "libs/webix-extra/hw/hwWizardV2/hwWizardTimeNodeV2.ts",
            "libs/webix-extra/hw/hwcombo/hwCombo.ts",
            "libs/webix-extra/hw/hwcombo/hwTextComboV2.ts",
            "libs/webix-extra/hw/hwedocfilemanage/cookieUtil.ts",
            "libs/webix-extra/hw/hwedocfilemanage/hwEdocFileManage.ts",
            "libs/webix-extra/hw/hwedocfilemanage/jalorEdocFileList.ts",
            "libs/webix-extra/hw/hwedocfilemanage/jalorEdocFileManager.ts",
            "libs/webix-extra/hw/hwedocfilemanage/templateListDialog.ts",
            "libs/webix-extra/hw/hwfiltersearch/filterSearch.less!github:social4hyq/systemjs-less-plugin@1.8.1/less.js",
            "libs/webix-extra/hw/hwfiltersearch/filterSearch.ts",
            "libs/webix-extra/hw/hwmessagedialog/hwMessageDialog.ts",
            "libs/webix-extra/hw/hwmultidatepicker/hwmultidatepicker.ts",
            "libs/webix-extra/hw/hwmultiselect/hwchecksuggest.ts",
            "libs/webix-extra/hw/hwmultiselect/hwmultiselect.ts",
            "libs/webix-extra/hw/hwnumber/hwnumber.ts",
            "libs/webix-extra/hw/hwpath/hwpath.ts",
            "libs/webix-extra/hw/hwpopupV2/hwPopupV2.ts",
            "libs/webix-extra/hw/hwprogressbar/hwprogressbar.ts",
            "libs/webix-extra/hw/hwresponsivetable/responsivetable.less!github:social4hyq/systemjs-less-plugin@1.8.1/less.js",
            "libs/webix-extra/hw/hwresponsivetable/responsivetable.ts",
            "libs/webix-extra/hw/hwresponsivetreetable/responsivetable.less!github:social4hyq/systemjs-less-plugin@1.8.1/less.js",
            "libs/webix-extra/hw/hwresponsivetreetable/responsivetreetable.ts",
            "libs/webix-extra/hw/hwsuggestpopup/hwDatatableSuggest.ts",
            "libs/webix-extra/hw/hwsuggestpopup/hwGridSuggest.ts",
            "libs/webix-extra/hw/hwsuggestpopup/hwpopup.ts",
            "libs/webix-extra/hw/hwsuggestpopup/hwsuggest.ts",
            "libs/webix-extra/hw/hwsuggestpopup/hwsuggestpopup.ts",
            "libs/webix-extra/hw/hwsuggestpopup/hwtext.ts",
            "libs/webix-extra/hw/hwsuggestpopup/popWin.ts",
            "libs/webix-extra/hw/hwtextpopup/hwtextpopup.ts",
            "libs/webix-extra/hw/hwtooltip/hwtooltip.ts",
            "libs/webix-extra/hw/hwurl/hwurl.ts",
            "libs/webix-extra/hw/iscpIconTooltip/iscpIconTooltip.ts",
            "libs/webix-extra/hw/iscpLeftMenu/iscpLeftMenu.ts",
            "libs/webix-extra/hw/iscpLeftMenu/leftWindow.ts",
            "libs/webix-extra/hw/multiuser/multiuser.ts",
            "libs/webix-extra/hw/multiuser/multiuserSuggest.ts",
            "libs/webix-extra/hw/pluploader/dmauploader.ts",
            "libs/webix-extra/hw/pluploader/pluploader.ts",
            "libs/webix-extra/hw/pluploader/wpfuploader.ts",
            "libs/webix-extra/hw/social/hwSocialAsstLabel.ts",
            "libs/webix-extra/uiUtil.ts",
            "libs/webix-extra/util.ts",
            "libs/webix-extra/webix-extra-all-V2.ts",
            "libs/webix-extra/webix-extra-all.ts",
            "libs/webix-jet/WebixJetBase.ts"
        ],
        "libs/webix-jet/jet-core/helpers/customReportHelp/customReportHelp-62440a6f7f.bundle.ts": [
            "github:social4hyq/systemjs-less-plugin@1.8.1.json",
            "libs/webix-jet/jet-core/helpers/customReportHelp/ProgressWindow.less!github:social4hyq/systemjs-less-plugin@1.8.1/less.js",
            "libs/webix-jet/jet-core/helpers/customReportHelp/ProgressWindow.ts",
            "libs/webix-jet/jet-core/helpers/customReportHelp/apiList.ts",
            "libs/webix-jet/jet-core/helpers/customReportHelp/apiUtil.ts",
            "libs/webix-jet/jet-core/helpers/customReportHelp/crHelpWin.less!github:social4hyq/systemjs-less-plugin@1.8.1/less.js",
            "libs/webix-jet/jet-core/helpers/customReportHelp/crHelpWin.ts",
            "libs/webix-jet/jet-core/helpers/customReportHelp/customReportFun.ts",
            "libs/webix-jet/jet-core/helpers/customReportHelp/customReportHelp.ts",
            "libs/webix-jet/jet-core/helpers/customReportHelp/customReportWin.ts",
            "libs/webix-jet/jet-core/helpers/customReportHelp/customShareWin.ts",
            "libs/webix-jet/jet-core/helpers/customReportHelp/editDisReportWin.ts",
            "libs/webix-jet/jet-core/helpers/customReportHelp/i18n.ts"
        ],
        "libs/webix-jet/jet-core/helpers/hwa-ihelp-5a0c41f00e.bundle.ts": [
            "libs/webix-jet/jet-core/helpers/hwa.ts",
            "libs/webix-jet/jet-core/helpers/ihelp.ts"
        ],
        "libs/webix-skins/skins/iscp/ihelp/qrs/js/index-4e38f2060d.bundle.ts": [
            "libs/webix-skins/skins/iscp/ihelp/qrs/js/index.ts"
        ],
        "libs/webix-skins/skins/iscp/theme1/index-149d6bb8d9.bundle.ts": [
            "libs/webix-skins/skins/iscp/theme1/index.ts",
            "libs/webix-skins/skins/iscp/theme1/introjs.less!github:social4hyq/systemjs-less-plugin@1.8.1/less.js",
            "libs/webix-skins/skins/iscp/theme1/main.less!github:social4hyq/systemjs-less-plugin@1.8.1/less.js"
        ],
        "libs/webix-skins/skins/xcube/MAE/index-7e68ed1a6d.bundle.ts": [
            "libs/webix-skins/skins/xcube/MAE/index.ts",
            "libs/webix-skins/skins/xcube/MAE/main.less!github:social4hyq/systemjs-less-plugin@1.8.1/less.js"
        ],
        "libs/webix-skins/skins/xcube/df/index-341c9cbabe.bundle.ts": [
            "libs/webix-skins/skins/xcube/df/index.ts",
            "libs/webix-skins/skins/xcube/df/main.less!github:social4hyq/systemjs-less-plugin@1.8.1/less.js"
        ],
        "libs/webix-skins/skins/xcube/esales/index-7fb52a1ddc.bundle.ts": [
            "libs/webix-skins/skins/xcube/esales/index.ts",
            "libs/webix-skins/skins/xcube/esales/main.less!github:social4hyq/systemjs-less-plugin@1.8.1/less.js"
        ],
        "libs/webix-skins/skins/xcube/etreasury/index-705f84cd98.bundle.ts": [
            "libs/webix-skins/skins/xcube/etreasury/index.ts",
            "libs/webix-skins/skins/xcube/etreasury/main.less!github:social4hyq/systemjs-less-plugin@1.8.1/less.js"
        ],
        "libs/webix-skins/skins/xcube/icare/index-6514d0b0d6.bundle.ts": [
            "libs/webix-skins/skins/xcube/icare/index.ts",
            "libs/webix-skins/skins/xcube/icare/main.less!github:social4hyq/systemjs-less-plugin@1.8.1/less.js"
        ],
        "libs/webix-skins/skins/xcube/isales4/index-ad02eceecd.bundle.ts": [
            "libs/webix-skins/skins/xcube/isales4/index.ts",
            "libs/webix-skins/skins/xcube/isales4/main.less!github:social4hyq/systemjs-less-plugin@1.8.1/less.js"
        ],
        "libs/webix-skins/skins/xcube/isdp/index-45443b4913.bundle.ts": [
            "libs/webix-skins/skins/xcube/isdp/index.ts",
            "libs/webix-skins/skins/xcube/isdp/main.less!github:social4hyq/systemjs-less-plugin@1.8.1/less.js"
        ],
        "libs/webix-skins/skins/xcube/keystone/index-c4b69b3264.bundle.ts": [
            "libs/webix-skins/skins/xcube/keystone/index.ts",
            "libs/webix-skins/skins/xcube/keystone/main.less!github:social4hyq/systemjs-less-plugin@1.8.1/less.js"
        ],
        "libs/webix-skins/skins/xcube/mockup/index-475219d2ad.bundle.ts": [
            "libs/webix-skins/skins/xcube/mockup/index.ts",
            "libs/webix-skins/skins/xcube/mockup/main.less!github:social4hyq/systemjs-less-plugin@1.8.1/less.js"
        ],
        "libs/webix-skins/skins/xcube/procurement/index-2e628786b5.bundle.ts": [
            "libs/webix-skins/skins/xcube/procurement/index.ts",
            "libs/webix-skins/skins/xcube/procurement/main.less!github:social4hyq/systemjs-less-plugin@1.8.1/less.js"
        ],
        "libs/webix-skins/skins/xcube/theme1/index-9bd57551f6.bundle.ts": [
            "libs/webix-skins/skins/xcube/theme1/index.ts",
            "libs/webix-skins/skins/xcube/theme1/main.less!github:social4hyq/systemjs-less-plugin@1.8.1/less.js"
        ],
        "libs/webix-skins/skins/xcube/theme2/index-b77b345a74.bundle.ts": [
            "libs/webix-skins/skins/xcube/theme2/index.ts",
            "libs/webix-skins/skins/xcube/theme2/main.less!github:social4hyq/systemjs-less-plugin@1.8.1/less.js"
        ],
        "lodash-a87bfcdf95.bundle.ts": [
            "npm:lodash@4.15.0.json",
            "npm:lodash@4.15.0/lodash.js"
        ],
        "modules/common-locale-d9ecaa13b4.ts.bundle.ts": [
            "libs/webix-extra/locales/en.ts",
            "libs/webix-extra/locales/it.ts",
            "libs/webix-extra/locales/ru.ts",
            "libs/webix-extra/locales/zh.ts",
            "libs/webix/codebase/i18n/zh.js",
            "modules/common/locales/en.ts",
            "modules/common/locales/it.ts",
            "modules/common/locales/ru.ts",
            "modules/common/locales/zh.ts"
        ],
        "modules/entries-2b0a23191b.bundle.ts": [
            "github:systemjs/plugin-css@0.1.27.json",
            "libs/webix-extra/components/wangEditor/xss.js!js",
            "libs/webix-extra/webix-extra-all.less!github:social4hyq/systemjs-less-plugin@1.8.1/less.js",
            "libs/webix-jet/jet-core/helpers/hwa2.ts",
            "libs/webix-jet/jet-core/helpers/locale.ts",
            "libs/webix-skins/skins/iscp/theme1/index.ts",
            "libs/webix-skins/skins/iscp/theme1/introjs.less!github:social4hyq/systemjs-less-plugin@1.8.1/less.js",
            "libs/webix-skins/skins/iscp/theme1/main.less!github:social4hyq/systemjs-less-plugin@1.8.1/less.js",
            "modules/common/extra/driver/jalor5.ts",
            "modules/common/extra/proxy/errorPopupHinter.ts",
            "modules/common/extra/proxy/jalor5.ts",
            "modules/common/extra/proxy/jalor6.ts",
            "modules/common/extra/util.ts",
            "modules/demo/index.ts",
            "modules/iframe.ts",
            "modules/portal-lite.ts",
            "modules/portal.ts",
            "modules/portal/PrivacyAgreement/PrivacyAgreement.less!github:social4hyq/systemjs-less-plugin@1.8.1/less.js",
            "modules/portal/PrivacyAgreement/PrivacyAgreement.ts",
            "modules/portal/PrivacyAgreement/cookieStatement.css!github:systemjs/plugin-css@0.1.27/css.js",
            "modules/portal/PrivacyAgreement/cookieStatement.js",
            "modules/portal/bulletin/bulletin.less!github:social4hyq/systemjs-less-plugin@1.8.1/less.js",
            "modules/portal/bulletin/bulletin.ts",
            "modules/portal/bulletin/bulletinworkspace.ts",
            "modules/portal/bulletin/messagePop.ts",
            "modules/portal/common/apiList.ts",
            "modules/portal/common/apiUtil.ts",
            "modules/portal/common/gUtil.ts",
            "modules/portal/common/hwa2Init.ts",
            "modules/portal/empty.ts",
            "modules/portal/parts/RiskInformationPop.ts",
            "modules/portal/parts/RiskInformationSet.ts",
            "modules/portal/parts/esupplierHeader.ts",
            "modules/portal/parts/header/esupplierStyle.less!github:social4hyq/systemjs-less-plugin@1.8.1/less.js",
            "modules/portal/parts/util/apply/index.less!github:social4hyq/systemjs-less-plugin@1.8.1/less.js",
            "modules/portal/parts/util/apply/index.ts",
            "modules/portal/parts/util/esupplierMenu.less!github:social4hyq/systemjs-less-plugin@1.8.1/less.js",
            "modules/portal/parts/util/esupplierMenu.ts",
            "modules/portal/parts/util/iframes.less!github:social4hyq/systemjs-less-plugin@1.8.1/less.js",
            "modules/portal/parts/util/menu.less!github:social4hyq/systemjs-less-plugin@1.8.1/less.js",
            "modules/portal/parts/util/menuUtil.ts",
            "modules/portal/parts/util/permissions.less!github:social4hyq/systemjs-less-plugin@1.8.1/less.js",
            "modules/portal/parts/util/permissions.ts",
            "modules/portal/parts/util/scrollMenu.ts",
            "modules/portal/parts/util/searchMenu.less!github:social4hyq/systemjs-less-plugin@1.8.1/less.js",
            "modules/portal/parts/util/searchMenu.ts",
            "modules/portal/parts/util/toolbar.less!github:social4hyq/systemjs-less-plugin@1.8.1/less.js",
            "modules/portal/parts/util/toolbar.ts",
            "modules/portal/parts/util/transformUrl.ts",
            "modules/portal/parts/util/utils.ts",
            "modules/portal/socialCenter/commonFun.ts",
            "modules/portal/socialCenter/createApproveTaskWin.ts",
            "modules/portal/socialCenter/createCollaborationTicket.ts",
            "modules/portal/socialCenter/createSocialWin.less!github:social4hyq/systemjs-less-plugin@1.8.1/less.js",
            "modules/portal/socialCenter/createSocialWin.ts",
            "modules/portal/socialCenter/hwLogV2.ts",
            "modules/portal/socialCenter/socialCenterApproveTask.ts",
            "modules/portal/socialCenter/socialCenterBulletin.ts",
            "modules/portal/socialCenter/socialCenterDetail.ts",
            "modules/portal/socialCenter/socialCenterList.ts",
            "modules/portal/socialCenter/socialCenterRisk.ts",
            "modules/portal/socialCenter/socialCenterWin.less!github:social4hyq/systemjs-less-plugin@1.8.1/less.js",
            "modules/portal/socialCenter/socialCenterWin.ts",
            "modules/portal/socialCenter/socialCenteriWork.ts",
            "modules/portal/socialCenter/socialIndex.ts",
            "modules/portal/socialCenter/util.ts",
            "modules/typings.d.ts",
            "npm:lodash@4.15.0/_Symbol.js",
            "npm:lodash@4.15.0/_arrayLikeKeys.js",
            "npm:lodash@4.15.0/_arrayMap.js",
            "npm:lodash@4.15.0/_baseClamp.js",
            "npm:lodash@4.15.0/_baseFindIndex.js",
            "npm:lodash@4.15.0/_baseIndexOf.js",
            "npm:lodash@4.15.0/_baseIsNaN.js",
            "npm:lodash@4.15.0/_baseKeys.js",
            "npm:lodash@4.15.0/_baseTimes.js",
            "npm:lodash@4.15.0/_baseToString.js",
            "npm:lodash@4.15.0/_baseValues.js",
            "npm:lodash@4.15.0/_freeGlobal.js",
            "npm:lodash@4.15.0/_isIndex.js",
            "npm:lodash@4.15.0/_isPrototype.js",
            "npm:lodash@4.15.0/_nativeKeys.js",
            "npm:lodash@4.15.0/_overArg.js",
            "npm:lodash@4.15.0/_root.js",
            "npm:lodash@4.15.0/includes.js",
            "npm:lodash@4.15.0/isArguments.js",
            "npm:lodash@4.15.0/isArray.js",
            "npm:lodash@4.15.0/isArrayLike.js",
            "npm:lodash@4.15.0/isArrayLikeObject.js",
            "npm:lodash@4.15.0/isFunction.js",
            "npm:lodash@4.15.0/isLength.js",
            "npm:lodash@4.15.0/isObject.js",
            "npm:lodash@4.15.0/isObjectLike.js",
            "npm:lodash@4.15.0/isString.js",
            "npm:lodash@4.15.0/isSymbol.js",
            "npm:lodash@4.15.0/keys.js",
            "npm:lodash@4.15.0/startsWith.js",
            "npm:lodash@4.15.0/toFinite.js",
            "npm:lodash@4.15.0/toInteger.js",
            "npm:lodash@4.15.0/toNumber.js",
            "npm:lodash@4.15.0/toString.js",
            "npm:lodash@4.15.0/values.js"
        ],
        "modules/portal/home-cbbf644904.bundle.ts": [
            "libs/webix-jet/jet-core/helpers/ihelp2.ts",
            "modules/portal/home.ts",
            "modules/portal/home/app-store.less!github:social4hyq/systemjs-less-plugin@1.8.1/less.js"
        ],
        "modules/portal/listport/all-79574bc45d.ts.bundle.ts": [
            "github:systemjs/plugin-css@0.1.27.json",
            "libs/webix-extra/components/echarts.js!js",
            "libs/webix-extra/components/wangEditor.js",
            "libs/webix-extra/components/wangEditor/wangEditor.min.css!github:systemjs/plugin-css@0.1.27/css.js",
            "libs/webix-jet/jet-core/helpers/hwa2.ts",
            "libs/webix-jet/jet-core/helpers/ihelp2.ts",
            "modules/common/commoncard/assets/css/common-card.less!github:social4hyq/systemjs-less-plugin@1.8.1/less.js",
            "modules/common/commoncard/helper.less!github:social4hyq/systemjs-less-plugin@1.8.1/less.js",
            "modules/common/commoncard/helper.ts",
            "modules/common/extra/util.ts",
            "modules/portal/common/constant.ts",
            "modules/portal/common/dialoger/dialoger.less!github:social4hyq/systemjs-less-plugin@1.8.1/less.js",
            "modules/portal/common/dialoger/dialoger.ts",
            "modules/portal/common/gUtil.ts",
            "modules/portal/common/hwa2Init.ts",
            "modules/portal/common/resizerV2/resizerV2.less!github:social4hyq/systemjs-less-plugin@1.8.1/less.js",
            "modules/portal/common/resizerV2/resizerV2.ts",
            "modules/portal/listport/EncodeAndDecode.ts",
            "modules/portal/listport/dateUtils.ts",
            "modules/portal/listport/excolumns.ts",
            "modules/portal/listport/exmain.ts",
            "modules/portal/listport/form.ts",
            "modules/portal/listport/form2.ts",
            "modules/portal/listport/incolumns.ts",
            "modules/portal/listport/index.ts",
            "modules/portal/listport/index2.ts",
            "modules/portal/listport/inmain.ts",
            "modules/portal/listport/listport.less!github:social4hyq/systemjs-less-plugin@1.8.1/less.js",
            "modules/portal/listport/listportdriver.ts",
            "modules/portal/listport/tab.ts",
            "modules/portal/listport/tab2.ts",
            "modules/portal/page/nopermission.less!github:social4hyq/systemjs-less-plugin@1.8.1/less.js",
            "modules/portal/page/nopermission.ts",
            "modules/portal/page/permissionRecommend.less!github:social4hyq/systemjs-less-plugin@1.8.1/less.js",
            "modules/portal/page/roles.less!github:social4hyq/systemjs-less-plugin@1.8.1/less.js",
            "modules/portal/page/roles.ts",
            "modules/portal/page/todo.less!github:social4hyq/systemjs-less-plugin@1.8.1/less.js",
            "modules/portal/parts/util/utils.ts",
            "modules/portal/socialCenter/commonFun.ts",
            "modules/portal/userCenter/aboutPage/dioag.ts",
            "modules/portal/userCenter/aboutPage/index.ts",
            "modules/portal/userCenter/apply/index.ts",
            "modules/portal/userCenter/approve/card.ts",
            "modules/portal/userCenter/approve/desktop.ts",
            "modules/portal/userCenter/approve/index.ts",
            "modules/portal/userCenter/approve/proxy/jalor5fix.ts",
            "modules/portal/userCenter/approve/proxy/jalor6fix.ts",
            "modules/portal/userCenter/basedata/basedata.ts",
            "modules/portal/userCenter/basedata/index.ts",
            "modules/portal/userCenter/details.less!github:social4hyq/systemjs-less-plugin@1.8.1/less.js",
            "modules/portal/userCenter/helpDocumentSet.ts",
            "modules/portal/userCenter/helper.ts",
            "modules/portal/userCenter/index.less!github:social4hyq/systemjs-less-plugin@1.8.1/less.js",
            "modules/portal/userCenter/index.ts",
            "modules/portal/userCenter/monitor/console.ts",
            "modules/portal/userCenter/monitor/index.less!github:social4hyq/systemjs-less-plugin@1.8.1/less.js",
            "modules/portal/userCenter/monitor/index.ts",
            "modules/portal/userCenter/monitor/rule.ts",
            "modules/portal/userCenter/myMessage.ts",
            "modules/portal/userCenter/myTodo.ts",
            "modules/portal/userCenter/proxyServiceWhitelistSet.ts",
            "modules/portal/userCenter/sendMessageBox.ts",
            "modules/portal/userCenter/timer/index.ts",
            "modules/portal/userCenter/timer/timer-config.ts",
            "modules/portal/userCenter/timer/timer-record.ts",
            "modules/portal/userCenter/timer/useraccount.ts",
            "modules/portal/userCenter/timezone.ts",
            "modules/portal/userCenter/todoList.ts"
        ],
        "modules/portal/page/all-c8a552f834.ts.bundle.ts": [
            "libs/webix-jet/jet-core/helpers/customReportHelp/crHelp.ts",
            "libs/webix-jet/jet-core/helpers/hwa2.ts",
            "libs/webix-jet/jet-core/helpers/ihelp2.ts",
            "modules/portal/common/hwa2Init.ts",
            "modules/portal/common/resizerV2/resizerV2.less!github:social4hyq/systemjs-less-plugin@1.8.1/less.js",
            "modules/portal/common/resizerV2/resizerV2.ts",
            "modules/portal/page/applyingPermissionsWindow.ts",
            "modules/portal/page/cr/crIframeUI.ts",
            "modules/portal/page/cr/index.less!github:social4hyq/systemjs-less-plugin@1.8.1/less.js",
            "modules/portal/page/cr/util.ts",
            "modules/portal/page/crEditReport.ts",
            "modules/portal/page/crInfo.ts",
            "modules/portal/page/crList.ts",
            "modules/portal/page/esupplierNopermission.ts",
            "modules/portal/page/nopermission.less!github:social4hyq/systemjs-less-plugin@1.8.1/less.js",
            "modules/portal/page/nopermission.ts",
            "modules/portal/page/permissionRecommend.less!github:social4hyq/systemjs-less-plugin@1.8.1/less.js",
            "modules/portal/page/rolelist.less!github:social4hyq/systemjs-less-plugin@1.8.1/less.js",
            "modules/portal/page/rolelist.ts",
            "modules/portal/page/roles.less!github:social4hyq/systemjs-less-plugin@1.8.1/less.js",
            "modules/portal/page/roles.ts",
            "modules/portal/parts/util/utils.ts"
        ],
        "modules/portal/page/authority/all-0489a15749.ts.bundle.ts": [
            "modules/portal/page/authority/authority.less!github:social4hyq/systemjs-less-plugin@1.8.1/less.js",
            "modules/portal/page/authority/funcPopWin.ts",
            "modules/portal/page/authority/home.ts",
            "modules/portal/page/authority/matrix.ts",
            "modules/portal/page/authority/rolePopWin.ts",
            "modules/portal/page/authority/search.ts"
        ]
    },
    "devConfig": {
        "map": {
            "http": "npm:jspm-nodelibs-http@0.2.0",
            "https": "npm:jspm-nodelibs-https@0.2.0",
            "systemjs-hot-reloader": "github:capaj/systemjs-hot-reloader@0.6.0",
            "url": "npm:jspm-nodelibs-url@0.2.0"
        },
        "packages": {
            "github:capaj/systemjs-hot-reloader@0.6.0": {
                "map": {
                    "debug": "npm:debug@2.2.0",
                    "socket.io-client": "github:socketio/socket.io-client@1.4.8",
                    "weakee": "npm:weakee@1.0.0"
                }
            },
            "npm:debug@2.2.0": {
                "map": {
                    "ms": "npm:ms@0.7.1"
                }
            },
            "npm:jspm-nodelibs-http@0.2.0": {
                "map": {
                    "http-browserify": "npm:stream-http@2.4.0"
                }
            },
            "npm:jspm-nodelibs-url@0.2.0": {
                "map": {
                    "url-browserify": "npm:url@0.11.0"
                }
            },
            "npm:readable-stream@2.1.5": {
                "map": {
                    "buffer-shims": "npm:buffer-shims@1.0.0",
                    "core-util-is": "npm:core-util-is@1.0.2",
                    "inherits": "npm:inherits@2.0.3",
                    "isarray": "npm:isarray@1.0.0",
                    "process-nextick-args": "npm:process-nextick-args@1.0.7",
                    "string_decoder": "npm:string_decoder@0.10.31",
                    "util-deprecate": "npm:util-deprecate@1.0.2"
                }
            },
            "npm:stream-http@2.4.0": {
                "map": {
                    "builtin-status-codes": "npm:builtin-status-codes@2.0.0",
                    "inherits": "npm:inherits@2.0.3",
                    "readable-stream": "npm:readable-stream@2.1.5",
                    "to-arraybuffer": "npm:to-arraybuffer@1.0.1",
                    "xtend": "npm:xtend@4.0.1"
                }
            },
            "npm:url@0.11.0": {
                "map": {
                    "punycode": "npm:punycode@1.3.2",
                    "querystring": "npm:querystring@0.2.0"
                }
            }
        }
    },
    "map": {
        "app": "app.ts",
        "assert": "npm:jspm-nodelibs-assert@0.2.0",
        "buffer": "npm:jspm-nodelibs-buffer@0.2.0",
        "child_process": "npm:jspm-nodelibs-child_process@0.2.0",
        "constants": "npm:jspm-nodelibs-constants@0.2.0",
        "crypto": "npm:jspm-nodelibs-crypto@0.2.0",
        "css": "github:systemjs/plugin-css@0.1.27",
        "env": "env.ts",
        "events": "npm:jspm-nodelibs-events@0.2.0",
        "fs": "npm:jspm-nodelibs-fs@0.2.0",
        "introjs": "npm:intro.js@2.3.0",
        "introjs.css": "npm:intro.js@2.3.0",
        "json": "github:systemjs/plugin-json@0.1.2",
        "less": "github:social4hyq/systemjs-less-plugin@1.8.1",
        "locale": "locale.ts",
        "lodash": "npm:lodash@4.15.0",
        "md": "github:guybedford/system-md@0.1.0",
        "module": "npm:jspm-nodelibs-module@0.2.0",
        "moment": "npm:moment@2.14.1",
        "moment-timezone": "npm:moment-timezone@0.5.5",
        "net": "npm:jspm-nodelibs-net@0.2.0",
        "os": "npm:jspm-nodelibs-os@0.2.0",
        "path": "npm:jspm-nodelibs-path@0.2.0",
        "polyglot": "libs/webix-jet/polyglot/build/polyglot",
        "process": "npm:jspm-nodelibs-process@0.2.0",
        "raphael": "npm:raphael@2.2.0",
        "source-map": "npm:source-map@0.2.0",
        "stream": "npm:jspm-nodelibs-stream@0.2.0",
        "string_decoder": "npm:jspm-nodelibs-string_decoder@0.2.0",
        "text": "github:systemjs/plugin-text@0.0.7",
        "timers": "npm:jspm-nodelibs-timers@0.2.0",
        "ts": "github:frankwallis/plugin-typescript@5.3.0",
        "tty": "npm:jspm-nodelibs-tty@0.2.0",
        "util": "npm:jspm-nodelibs-util@0.2.0",
        "vm": "npm:jspm-nodelibs-vm@0.2.0"
    },
    "meta": {
        "*.md": {
            "loader": "md",
            "mdOptions": {
                "tables": true
            }
        },
        "*.ts": {
            "loader": "ts"
        }
    },
    "packageConfigPaths": [
        "npm:@*/*.json",
        "npm:*.json",
        "github:*/*.json"
    ],
    "packages": {
        "github:frankwallis/plugin-typescript@5.3.0": {
            "map": {
                "typescript": "npm:typescript@2.1.1"
            }
        },
        "github:guybedford/system-md@0.1.0": {
            "map": {
                "showdown": "github:showdownjs/showdown@1.4.3"
            }
        },
        "libs/webix": {
            "defaultExtension": "js"
        },
        "libs/webix-extra": {
            "defaultExtension": "ts"
        },
        "libs/webix-extra/components": {
            "defaultExtension": "js",
            "meta": {
                "*.js": {
                    "loader": "ts"
                }
            }
        },
        "libs/webix-jet": {
            "defaultExtension": "ts"
        },
        "libs/webix-jet/polyglot": {
            "defaultExtension": "js"
        },
        "libs/webix-jet/routie": {
            "defaultExtension": "js"
        },
        "libs/webix-skins": {
            "defaultExtension": "ts"
        },
        "modules": {
            "defaultExtension": "ts",
            "meta": {
                "*.js": {
                    "loader": "ts"
                }
            }
        },
        "npm:asn1.js@4.9.0": {
            "map": {
                "bn.js": "npm:bn.js@4.11.6",
                "inherits": "npm:inherits@2.0.3",
                "minimalistic-assert": "npm:minimalistic-assert@1.0.0"
            }
        },
        "npm:browserify-aes@1.0.6": {
            "map": {
                "buffer-xor": "npm:buffer-xor@1.0.3",
                "cipher-base": "npm:cipher-base@1.0.3",
                "create-hash": "npm:create-hash@1.1.2",
                "evp_bytestokey": "npm:evp_bytestokey@1.0.0",
                "inherits": "npm:inherits@2.0.3"
            }
        },
        "npm:browserify-cipher@1.0.0": {
            "map": {
                "browserify-aes": "npm:browserify-aes@1.0.6",
                "browserify-des": "npm:browserify-des@1.0.0",
                "evp_bytestokey": "npm:evp_bytestokey@1.0.0"
            }
        },
        "npm:browserify-des@1.0.0": {
            "map": {
                "cipher-base": "npm:cipher-base@1.0.3",
                "des.js": "npm:des.js@1.0.0",
                "inherits": "npm:inherits@2.0.3"
            }
        },
        "npm:browserify-rsa@4.0.1": {
            "map": {
                "bn.js": "npm:bn.js@4.11.6",
                "randombytes": "npm:randombytes@2.0.3"
            }
        },
        "npm:browserify-sign@4.0.0": {
            "map": {
                "bn.js": "npm:bn.js@4.11.6",
                "browserify-rsa": "npm:browserify-rsa@4.0.1",
                "create-hash": "npm:create-hash@1.1.2",
                "create-hmac": "npm:create-hmac@1.1.4",
                "elliptic": "npm:elliptic@6.3.2",
                "inherits": "npm:inherits@2.0.3",
                "parse-asn1": "npm:parse-asn1@5.0.0"
            }
        },
        "npm:buffer@4.9.1": {
            "map": {
                "base64-js": "npm:base64-js@1.2.0",
                "ieee754": "npm:ieee754@1.1.8",
                "isarray": "npm:isarray@1.0.0"
            }
        },
        "npm:cipher-base@1.0.3": {
            "map": {
                "inherits": "npm:inherits@2.0.3"
            }
        },
        "npm:create-ecdh@4.0.0": {
            "map": {
                "bn.js": "npm:bn.js@4.11.6",
                "elliptic": "npm:elliptic@6.3.2"
            }
        },
        "npm:create-hash@1.1.2": {
            "map": {
                "cipher-base": "npm:cipher-base@1.0.3",
                "inherits": "npm:inherits@2.0.3",
                "ripemd160": "npm:ripemd160@1.0.1",
                "sha.js": "npm:sha.js@2.4.8"
            }
        },
        "npm:create-hmac@1.1.4": {
            "map": {
                "create-hash": "npm:create-hash@1.1.2",
                "inherits": "npm:inherits@2.0.3"
            }
        },
        "npm:crypto-browserify@3.11.0": {
            "map": {
                "browserify-cipher": "npm:browserify-cipher@1.0.0",
                "browserify-sign": "npm:browserify-sign@4.0.0",
                "create-ecdh": "npm:create-ecdh@4.0.0",
                "create-hash": "npm:create-hash@1.1.2",
                "create-hmac": "npm:create-hmac@1.1.4",
                "diffie-hellman": "npm:diffie-hellman@5.0.2",
                "inherits": "npm:inherits@2.0.3",
                "pbkdf2": "npm:pbkdf2@3.0.9",
                "public-encrypt": "npm:public-encrypt@4.0.0",
                "randombytes": "npm:randombytes@2.0.3"
            }
        },
        "npm:des.js@1.0.0": {
            "map": {
                "inherits": "npm:inherits@2.0.3",
                "minimalistic-assert": "npm:minimalistic-assert@1.0.0"
            }
        },
        "npm:diffie-hellman@5.0.2": {
            "map": {
                "bn.js": "npm:bn.js@4.11.6",
                "miller-rabin": "npm:miller-rabin@4.0.0",
                "randombytes": "npm:randombytes@2.0.3"
            }
        },
        "npm:elliptic@6.3.2": {
            "map": {
                "bn.js": "npm:bn.js@4.11.6",
                "brorand": "npm:brorand@1.0.6",
                "hash.js": "npm:hash.js@1.0.3",
                "inherits": "npm:inherits@2.0.3"
            }
        },
        "npm:evp_bytestokey@1.0.0": {
            "map": {
                "create-hash": "npm:create-hash@1.1.2"
            }
        },
        "npm:hash.js@1.0.3": {
            "map": {
                "inherits": "npm:inherits@2.0.3"
            }
        },
        "npm:jspm-nodelibs-buffer@0.2.0": {
            "map": {
                "buffer-browserify": "npm:buffer@4.9.1"
            }
        },
        "npm:jspm-nodelibs-crypto@0.2.0": {
            "map": {
                "crypto-browserify": "npm:crypto-browserify@3.11.0"
            }
        },
        "npm:jspm-nodelibs-os@0.2.0": {
            "map": {
                "os-browserify": "npm:os-browserify@0.2.1"
            }
        },
        "npm:jspm-nodelibs-stream@0.2.0": {
            "map": {
                "stream-browserify": "npm:stream-browserify@2.0.1"
            }
        },
        "npm:jspm-nodelibs-string_decoder@0.2.0": {
            "map": {
                "string_decoder-browserify": "npm:string_decoder@0.10.31"
            }
        },
        "npm:jspm-nodelibs-timers@0.2.0": {
            "map": {
                "timers-browserify": "npm:timers-browserify@1.4.2"
            }
        },
        "npm:miller-rabin@4.0.0": {
            "map": {
                "bn.js": "npm:bn.js@4.11.6",
                "brorand": "npm:brorand@1.0.6"
            }
        },
        "npm:moment-timezone@0.5.5": {
            "map": {
                "moment": "npm:moment@2.14.1"
            }
        },
        "npm:parse-asn1@5.0.0": {
            "map": {
                "asn1.js": "npm:asn1.js@4.9.0",
                "browserify-aes": "npm:browserify-aes@1.0.6",
                "create-hash": "npm:create-hash@1.1.2",
                "evp_bytestokey": "npm:evp_bytestokey@1.0.0",
                "pbkdf2": "npm:pbkdf2@3.0.9"
            }
        },
        "npm:pbkdf2@3.0.9": {
            "map": {
                "create-hmac": "npm:create-hmac@1.1.4"
            }
        },
        "npm:public-encrypt@4.0.0": {
            "map": {
                "bn.js": "npm:bn.js@4.11.6",
                "browserify-rsa": "npm:browserify-rsa@4.0.1",
                "create-hash": "npm:create-hash@1.1.2",
                "parse-asn1": "npm:parse-asn1@5.0.0",
                "randombytes": "npm:randombytes@2.0.3"
            }
        },
        "npm:raphael@2.2.0": {
            "map": {
                "eve": "github:adobe-webplatform/eve@0.2.4"
            }
        },
        "npm:readable-stream@2.2.2": {
            "map": {
                "buffer-shims": "npm:buffer-shims@1.0.0",
                "core-util-is": "npm:core-util-is@1.0.2",
                "inherits": "npm:inherits@2.0.3",
                "isarray": "npm:isarray@1.0.0",
                "process-nextick-args": "npm:process-nextick-args@1.0.7",
                "string_decoder": "npm:string_decoder@0.10.31",
                "util-deprecate": "npm:util-deprecate@1.0.2"
            }
        },
        "npm:sha.js@2.4.8": {
            "map": {
                "inherits": "npm:inherits@2.0.3"
            }
        },
        "npm:source-map-support@0.4.6": {
            "map": {
                "source-map": "npm:source-map@0.5.6"
            }
        },
        "npm:source-map@0.2.0": {
            "map": {
                "amdefine": "npm:amdefine@1.0.0"
            }
        },
        "npm:stream-browserify@2.0.1": {
            "map": {
                "inherits": "npm:inherits@2.0.3",
                "readable-stream": "npm:readable-stream@2.2.2"
            }
        },
        "npm:timers-browserify@1.4.2": {
            "map": {
                "process": "npm:process@0.11.9"
            }
        },
        "npm:typescript@2.1.1": {
            "map": {
                "source-map-support": "npm:source-map-support@0.4.6"
            }
        }
    },
    "transpiler": "ts",
    "typescriptOptions": {
        "tsconfig": true,
        "typeCheck": false
    }
});